import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DealService } from '../deal.service';
import { Deal, DealPayment } from '../model';
import { Panel } from 'primeng/panel';
import { IftaLabelModule } from 'primeng/iftalabel';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { TagModule } from 'primeng/tag';
import { PaymenMethodPipe } from '../pipes/payment-method.pipe';
import { OverdueCategoryPipe } from '../pipes/overdue-category.pipe';
import { DealTypePipe } from '../pipes/deal-type.pipe';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { NotificationTypePipe } from '../pipes/notification-type.pipe';
import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';

/*
Deal pipeline
status άδειας χρήσης (ενεργή / ανενεργή) - σύμφωνα με τη βάση
status 3rd party καναλιών (ενεργά / ανενεργά) - σύμφωνα με τη βάση
ημ/νία ενεργοποίησης άδειας χρήσης από το billing
ημ/νία απενεργοποίησης άδειας χρήσης από το billing
ημ/νία ενεργοποίησης 3rd party από το billing
ημ/νία απενεργοποίησης 3rd party από το billing
*/
@Component({
  selector: 'app-deal-view',
  imports: [
    FormsModule, CommonModule,
    InputTextModule, TableModule, CheckboxModule, TagModule, ButtonModule, ToolbarModule,
    Panel, IftaLabelModule, DialogModule, DatePickerModule,
    DatePipe, PaymenMethodPipe, OverdueCategoryPipe, DealTypePipe, DecimalPipe, NotificationTypePipe
  ],
  templateUrl: './deal-view.component.html',
  styleUrl: './deal-view.component.scss'
})
export class DealViewComponent implements OnInit {

  deal: Deal | null = null;
  protected hasCancelInfo = false;
  protected isLoading: boolean = false;
  protected modifyPaymentModalVisible: boolean = false;
  updatedDate: Date = new Date();
  protected updateComments = "";
  protected editingPayment: DealPayment | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: DealService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.url.subscribe(url => {
      const id = parseInt(url[2]?.path ?? 0);
      this.isLoading = true;

      this.service.get(id).subscribe(data => {
        this.isLoading = false;
        this.deal = data;
        this.hasCancelInfo = this.deal?.cancelInfo != null && Object.values(this.deal.cancelInfo).find(c => c != null && c != "") != null;
      });
    });
  }

  downloadPdf(): void {
    if (!this.deal) return;

    this.service.previewOfferPDF(this.deal.crmid).subscribe((response: Blob) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = `deal_${this.deal?.id}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }

  updateDealDataForRenewal(): void {
    if (!this.deal) return;

    this.service.updateDealDataForRenewal(this.deal.crmid).subscribe(data => {
      if (data != null) {
        this.deal = data;
      }
    });
  }

  showModifyPaymentModal(payment: DealPayment): void {
    this.modifyPaymentModalVisible = true;
    this.editingPayment = payment;
    this.updatedDate = new Date(payment.dueDate);
  }

  submitModification() {
    if (this.editingPayment == null) return;

    this.isLoading = true;
    this.modifyPaymentModalVisible = false;

    this.service.modifyPayment(this.editingPayment.id ?? 0, this.updatedDate, this.updateComments).subscribe(() => {
      this.service.get(parseInt(this.deal?.crmid ?? "0")).subscribe(data => {
        this.isLoading = false;
        this.deal = data;
        this.hasCancelInfo = this.deal?.cancelInfo != null && Object.values(this.deal.cancelInfo).find(c => c != null && c != "") != null;
      });
    });
  }

}
